import {REFRESH_SAMPLE_LIST_NEW} from '../actions/sampleListNew';

const initState = {
  samples: {
    data: null
  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_SAMPLE_LIST_NEW: {
      const {samplesData} = action;
      return Object.assign({}, state, {
        samples: Object.assign({}, state.samples, {
          data: samplesData
        })
      });
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/sampleListNew.js